// extracted by mini-css-extract-plugin
export default {"UpdateKeyGiverDrop":"UpdateKeyGiverDrop_UpdateKeyGiverDrop__md7tV","form":"UpdateKeyGiverDrop_form__8evDZ"};